import { type HTMLAttributes } from 'react';

import { usePanelPlacement } from '../services/usePanelPlacement';
import type { SavedDocumentPanelAnchor } from '../store';

interface FloatingPanelProps extends HTMLAttributes<HTMLDivElement> {
  rootElement: HTMLElement | null;
  getCoveredTop: () => number;
  anchor: SavedDocumentPanelAnchor;
}

/**
 * A panel placed next to the text it opens from. Placing it re-renders only the panel. A render of
 * the editor while an input in the panel takes the focus would let Slate move the focus back.
 */
export const FloatingPanel = ({
  rootElement,
  getCoveredTop,
  anchor,
  style,
  children,
  ...restProps
}: FloatingPanelProps) => {
  const { setPanelElement, panelStyle } = usePanelPlacement({
    rootElement,
    getCoveredTop,
    anchor,
  });

  return (
    <div
      ref={setPanelElement}
      style={{ ...style, ...panelStyle }}
      {...restProps}
    >
      {children}
    </div>
  );
};
